import {Component, OnInit, OnDestroy , ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {NotifierService} from 'angular-notifier';
import {Filters, Formatters} from 'angular-slickgrid';
import {MessageService} from '../message.service';
import {CustomInputEditor} from '../custom-inputEditor';
import {RestApiService} from '../rest-api.service';
import {NgbModal , NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';


@Component({
  selector: 'app-ticket-fields',
  templateUrl: './ticket-fields.component.html',
  styleUrls: ['./ticket-fields.component.css']
})
export class TicketFieldsComponent implements OnInit, OnDestroy {

  displayed = true;
  name: string;
  dropdown: string;
  clientId: number;

  add = false;
  del = false;
  edit = false;
  view = false;

  displayData: any;

  isError = false;
  errorMessage: string;
  respObject: any;
  totalData: number;
  types = [];
  private notifier: NotifierService;
  typeSelected: any;
  // isDropdown: boolean;
  typeChecked: number;
  type: string;
  ttypes = [];
  categories = [];
  defaultValue: string;
  categorySelected: number;
  private category: any;
  nextOffset: number;
  previousOffset: number;
  collectionSize: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private baseFlag: any;
  private userAuth: Subscription;
  offset: number;

  categoryLoaded = true;
  private baseCategories = [];
  ticketTypes: any;
  cat = [];
  priorityType: number;
  ticketTypeId: number;
  dynamicFields = [];
  ticketSelected: number;
  ticketSelectedName = '';
  ticketFieldTicketName = 'text';
  isQuestion: string;
  dataLoaded:boolean;
  showSearch = true;
  isLoading = false;
  searchData: FormControl = new FormControl();
  fieldSelected: any;
  fields: any;
  ftype: string;
  showExportBtn = true;
  dataExcel = [];
  @ViewChild('scarch_content') private scarch_content;
  private searchModalReference: NgbModalRef;
  additionalField = [{'name': '', 'typeSelected':'1' , 'dropdown': '','isQuestion':'false'}];




  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      // console.log(item);
      switch (item.type) {
        case 'change':
          // console.log('changed', JSON.stringify(item));
          if (!this.messageService.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {
            if (confirm('Are you sure?')) {
              item.user_id = this.messageService.getUserId();
              this._rest.updateAdditionalFieldValue(item).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // console.log('data--Done');
                  this.notifier.notify('success', 'Updated successfully');
                } else {
                  // console.log('data--Not---Done');
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
              });
            }
          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.messageService.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              // console.log(JSON.stringify(item));
              this._rest.deleteTicketExtandMstTbl({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // this.totalData = this.totalData - 1;
                  // this.messageService.setTotalData(this.totalData);
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
              });
            }
          }
          break;
      }
    });
    // this.messageService.getUserAuth().subscribe(details => {
    //   console.log(JSON.stringify(details));
    //   if (details.length > 0) {
    //     this.add = details[0].addFlag;
    //     this.del = details[0].deleteFlag;
    //     this.view = details[0].viewFlag;
    //     this.edit = details[0].editFlag;
    //   } else {
    //     this.add = true;
    //     this.del = true;
    //     this.view = true;
    //     this.edit = true;
    //   }
    // });

  }


  ngOnInit() {
    this.dataLoaded=false;
    this.isQuestion = 'false';
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'Maintain TicketFields',
      openModalButton: 'Add TicketFields',
      searchModalButton: 'Search',
      breadcrumb: 'TicketFields',
      folderName: 'All TicketFields',
      tabName: 'TicketFields',
      exportBtn: 'Export to excel'

    };
    this.types = [{id: 1, name: 'text'}, {id: 2, name: 'date'}, {id: 3, name: 'numeric'}, {id: 4, name: 'dropdown'}];

    this.typeSelected = '1';

    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'name', name: 'Field', field: 'name', sortable: true, filterable: true,cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'type', name: 'type', field: 'fieldType', sortable: true, filterable: true
      },
      {
        id: 'dropdown', name: 'DropDown Value', field: 'predifinedValue', sortable: true, filterable: true,cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      // {
      //   id: 'default', name: 'Default Value', field: 'defaultValue', sortable: true, filterable: true, editor: {
      //     model: CustomInputEditor,
      //   }
      // },
      {
        id: 'ttype', name: 'Ticket Type', field: 'ttype', sortable: true, filterable: true
      },
      {
        id: 'cat', name: 'Category', field: 'category_id', sortable: true, filterable: true
      },
      {
        id: 'isQuestion', name: 'isQuestion', field: 'isQuestion', sortable: true, filterable: true, formatter: Formatters.checkmark,
        filter: {
          collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
          model: Filters.singleSelect,

          filterOptions: {
            autoDropWidth: true
          },
        }
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }
    this.searchData.valueChanges.subscribe(
      name => {
          this.isLoading = true;

          this._rest.searchAllReportFields( name, this.clientId).subscribe((res1) => {
              this.respObject = res1;
              this.isLoading = false;



              if (this.respObject.success) {
                  this.fields = this.respObject.details;
                  console.log("true"+ JSON.stringify(this.fields));


              } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
              }
          }, (err) => {
              this.isLoading = false;
              this.notifier.notify('error', this.messageService.SERVER_ERROR);
          });
      });
  }



  onPageLoad() {
        // this._rest.getFirstLevelCategory(this.clientId).subscribe((res1) => {
        //   this.respObject = res1;
        //   if (this.respObject.success) {
        //     this.isError = false;
        //     this.respObject.details.unshift({id: 0, name: 'Select Category'});
        //     this.categories = this.respObject.details;
        //     this.categorySelected = 0;
        //   } else {
        //     this.isError = true;
        //     this.errorMessage = this.respObject.errorMessage;
        //   }
        // }, (err) => {
        //   this.isError = true;
        //   this.errorMessage = this.messageService.SERVER_ERROR;
        // });
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          // console.log(JSON.stringify(this.respObject));
          if (this.respObject.success) {
            this.typeChecked = this.respObject.details[0].id;
            this.type = this.respObject.details[0].name;
            this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
            this.ttypes = this.respObject.details;
            this.ticketSelected = 0;
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });

      this._rest.getAdditionalFieldTypeList(this.clientId).subscribe((res2) => {
          this.respObject = res2;
          // console.log(JSON.stringify(this.respObject));
          if (this.respObject.success) {
              // this.typeChecked = this.respObject.details[0].id;
              // console.log('===============> ' + JSON.stringify(this.respObject.details) );
              this.types = this.respObject.details;
          } else {
              this.notifier.notify('error', this.respObject.errorMessage);
          }
      }, (err) => {
          this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  exportToExcel() {
    // console.log("okkk" +this.clientId);
    this._rest.getAllReportFields(this.clientId).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
            this.dataExcel = this.respObject.details;
            // console.log('true' + JSON.stringify(this.dataExcel));
            console.log("length"+this.dataExcel.length)
            this.messageService.exportAsExcelFile(this.dataExcel);
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
}


addAdditionalFieldDiv(){
  this.additionalField.push({'name': '', 'typeSelected':'1' , 'dropdown': '','isQuestion':'false'});


}


  openModal(content) {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      // this.name = '';
      // this.dropdown = '';
      // this.isDropdown = false;
      // this.typeSelected = '1';
      this.ticketSelected = 0;
      this.ticketTypes = [];
      this.additionalField = [{'name': '', 'typeSelected':'1' , 'dropdown': '','isQuestion':'false'}];
      this.modalService.open(content, {size: 'lg'}).result.then((result) => {
      }, (reason) => {

      });
    }
  }



  searchModal()  {
  
  
      this.ftype = '';
      this.fieldSelected = '';
      this.searchModalReference = this.modalService.open(this.scarch_content);
      this.searchModalReference.result.then((result) => {
      }, (reason) => {

      });

  }


  getDetails() {
    for (let i = 0; i < this.fields.length; i++) {
        if (this.fields[i].name === this.fieldSelected) {
           
            // this.userName = this.usrs[i].fieldType;
            for (let j = 0; j < this.types.length; j++) {
              if (this.fields[i].fieldType === this.types[j].id.toString()) {
                this.ftype = this.types[j].name;
                
                break;
              }
            }
        }
    }
}
search() {
  const data1 = [];
  for (let i = 0; i < this.fields.length; i++) {
      if (this.fields[i].name === this.fieldSelected) {
        for (let j = 0; j < this.types.length; j++) {
          if (this.fields[i].fieldType === this.types[j].id.toString()) {
            this.fields[i].fieldType = this.types[j].name;
            break;
          }
        }
        data1.push(this.fields[i]);
      }
  }
  this.page_no = 1;
  this.messageService.setTotalData(data1.length);
  this.messageService.setGridData(data1);
  this.searchModalReference.close();

}


  save() {
      let cats = '';
      let categoryName = '';
      let isError = false;
      const assetIds = [];
      // console.log('cat===' + JSON.stringify(this.cat));
      const catsArray = [];
      for (let i = 0; i < this.cat.length; i++) {
          if (this.cat[i].cid !== 0) {
            catsArray.push(this.cat[i]);
          }
        }
      for (let i = 0; i < catsArray.length; i++) {
          if (catsArray[i].cid !== 0) {
              cats += catsArray[i].cid;
              if (i !== catsArray.length - 1) {
                  cats += ',';
              }
              if (categoryName === '') {
                  categoryName = catsArray[i].catName;
              } else {
                  categoryName += ' / ' + catsArray[i].catName;
              }
              // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
          } else {
              isError = true;
              break;
          }
      }

      for(let i = 0 ; i <this.additionalField.length; i++){
        if(this.additionalField[i].name === ''){
          this.isError = true;
          this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
          break;
        }
      }
    const data = {
      clientId: this.clientId,
      ticketType: this.typeChecked,
      category_id: cats,
      additionalField:this.additionalField,
      createdBy: this.messageService.getUserId(),

        // fieldType: this.typeSelected,
      // defaultValue: this.defaultValue,
       // fieldName: this.name,

      // isQuestion : this.isQuestion
    };
    // if (Number(this.typeSelected) === 4) {
    //   data['predifinedValue'] = this.dropdown;
    // }
    if (!this.messageService.isBlankField(data)) {
       console.log('iiiiiiiiiii ', JSON.stringify(data));

      this._rest.insertTicketExtandMstTbl(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.isError = false;
          this.nextOffset = 0;
          this.page_no = 0;
          this.getTableData();
          // this.name = '';
          // this.dropdown = '';
          // this.typeSelected = '1';
          this.ticketSelected = 0;
          this.ticketTypes = [];
          this.additionalField = [{'name': '', 'typeSelected':'1' , 'dropdown': '','isQuestion':'false'}];

          // this.isDropdown = false;
          this.isQuestion = 'false';
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }


  getTableData() {
    if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded=false;
    this._rest.getTicketExtandMstTbl(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      for (let i = 0; i < this.respObject.details.dataObj.length; i++) {
        for (let j = 0; j < this.types.length; j++) {
          if (this.respObject.details.dataObj[i].fieldType === this.types[j].id.toString()) {
            this.respObject.details.dataObj[i].fieldType = this.types[j].name;
            // console.log('hello');
            break;
          }
        }
      }
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }


  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  onButtonChange(selectedIndex: any) {
      this.cat = [];
      this.typeChecked = this.ticketTypeId = this.ttypes[selectedIndex].id;
      this.ticketSelectedName = this.ttypes[selectedIndex].name;
      this._rest.getTicketCreateLoadingDtls(this.messageService.getUserId(), this.typeChecked, this.clientId).subscribe((res) => {
        this.respObject = res;
        this.categoryLoaded = true;
        if (this.respObject.success) {
          // this.baseCategories = JSON.parse(JSON.stringify(this.respObject.details[0].attribute));
          this.baseCategories = this.messageService.copyArray(this.respObject.details[0].attribute);
          this.ticketTypes = this.respObject.details[0].attribute;
          // this.priorityType = this.respObject.details[0].val.type;
          // // this.cat = [];
          // // this.clientId = this.respObject.details[0].clientId;
          // this.respObject.details[0].val.urgency.unshift({
          //   id: 0,
          //   name: 'Select Urgency'
          // });
          // this.respObject.details[0].val.impact.unshift({
          //   id: 0,
          //   name: 'Select Bussiness Impact'
          // });
        } else {
          this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
  }

  onTypeChange(selectedIndex: any) {
    this.ticketFieldTicketName = this.types[selectedIndex];
    // if (Number(this.typeSelected) === 4) {
    //   this.isDropdown = true;
    // } else {
    //   this.isDropdown = false;
    // }
  }

  /*onCategoryChange(ticket, selectedIndex) {
    this.category = this.categories[selectedIndex].name;
  }*/

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }

  onCategoryChange(ticket, option) {
    // console.log('+++++++++++++++++++++', JSON.stringify(ticket), typeof option, ticket.id);
    const opt = JSON.parse(option);
    // console.log('++++++++++++++' + JSON.stringify(opt));
    if (opt.type !== 'header') {
      // if (this.attachment.length > 0) {
      //     this.attachment = [];
      // }
      const value = opt.id;
      const catVal = opt.title;
      let matched = false;
      const index = this.ticketTypes.map(function (d) {
        return d['id'];
      }).indexOf(ticket.id + 1);
      // console.log('index:' + index);
      const index1 = this.ticketTypes.map(function (d) {
        return d['id'];
      }).indexOf(ticket.id);
      const pid = this.ticketTypes[index1].options[0].id;
      // console.log(this.ticketTypes[index1].options[0]);
      if (this.cat.length === 0) {
        this.cat.push({pid: pid, cid: value, catName: catVal});
      } else {
        for (let i = 0; i < this.cat.length; i++) {
          if (this.cat[i].pid === pid) {
            matched = true;
            this.cat[i].cid = value;
            this.cat[i].catName = catVal;
            break;
          }
        }
        if (!matched) {
          this.cat.push({pid: pid, cid: value, catName: catVal});
        } else {
          for (let i = index; i < this.cat.length; i++) {
            // console.log('matched');
            // console.log(this.cat[i]);
            if (index > -1) {
              this.cat[i].cid = 0;
            }
          }
        }
      }
      // clear sub categories
      if (index > -1) {
        // console.log('index:' + index);
        for (let i = index + 1; i < this.ticketTypes.length; i++) {
          const options = this.ticketTypes[i].options;
          // console.log(JSON.stringify(options));
          for (let j = 0; j < options.length; j++) {
            if (options[j].type) {
              // options=[];
              this.ticketTypes[i].options = [options[j]];
              break;
            }
          }
        }
      }
      // console.log(this.ticketTypeId);
      // if (ticket.id === 1) {
      //   // console.log('coma seperated values ', JSON.stringify(this.cat));
      //   // console.log('9999999999 values ', value);
      //   this._rest.getTicketFieldsCatWise({
      //     clientId: this.clientId,
      //     catId: value,
      //     ticketTypeId: this.ticketTypeId
      //   }).subscribe((res) => {
      //     this.respObject = res;
      //     if (this.respObject.success) {
      //       // console.log(JSON.stringify(this.respObject.details));
      //       for (let i = 0; i < this.respObject.details.length; i++) {
      //         if (this.respObject.details[i].predifinedValue !== null) {
      //           this.respObject.details[i].values = this.respObject.details[i].predifinedValue.split(',');
      //           this.respObject.details[i].value = this.respObject.details[i].values[0];
      //         } else {
      //           this.respObject.details[i].value = '';
      //         }
      //       }
      //       this.dynamicFields = this.respObject.details;
      //     } else {
      //       // this.notifier.notify('error', this.respObject.errorMessage);
      //     }
      //   }, (err) => {
      //     this.notifier.notify('error', this.messageService.SERVER_ERROR);
      //   });
      // }
      //
      // this._rest.getAttributesParentWiseWithPriority(this.clientId, value, this.priorityType, this.ticketTypeId).subscribe((res) => {
      //   this.respObject = res;
      //   // console.log(JSON.stringify(this.respObject));
      //   let data;
      //   if (index > -1) {
      //     data = this.ticketTypes[index].options[0];
      //   }
      //   if (this.respObject.success) {
      //     if (this.respObject.details.val) {
      //       // data = this.ticketTypes[index].options[0];
      //       this.respObject.details.val.unshift(data);
      //       this.ticketTypes[index].options = this.respObject.details.val;
      //     }
      //   } else {
      //     if (index > -1) {
      //       this.ticketTypes[index].options = [data];
      //     }
      //     // this.notifier.notify('error', this.respObject.errorMessage);
      //   }
      // }, (err) => {
      //   this.notifier.notify('error', this.messageService.SERVER_ERROR);
      // });
      this._rest.getAttributesParentWise(this.clientId, value).subscribe((res) => {
        this.respObject = res;
        // console.log(JSON.stringify(this.respObject));
        let data;
        if (index > -1) {
          data = this.ticketTypes[index].options[0];
        }
        if (this.respObject.success) {
          // data = this.ticketTypes[index].options[0];
          this.respObject.details.unshift(data);
          this.ticketTypes[index].options = this.respObject.details;
        } else {
          if (index > -1) {
            this.ticketTypes[index].options = [data];
          }
          // this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        // this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    }
  }
  c() {}
}
